<template>
  <div class="add-new-user">
    <form @submit.prevent="addUser">
      <table class="table table-create">
        <thead>
          <tr>
            <th
              colspan="4"
              class="text-center"
            >
              <h3>Add new user</h3>
            </th>
          </tr>
        </thead>
        <tr>
          <th>Name</th>
          <td>
            <input
              v-validate="$formValidator.rules.name"
              :error-messages="errors.collect('name')"
              :class="{
                'form-control': true,
                'is-invalid': errors.has('name')
              }"
              v-model="user.name"
              data-vv-name="name"
              type="text"
              class="form-control"
              placeholder="User Name">
            <div :class="{ 'validation-feedback': true, 'invalid-feedback': errors.has('name') }">
              {{ errors.first('name') }}
            </div>
          </td>
        </tr>
        <tr>
          <th>Email</th>
          <td>
            <input
              v-validate="'required|' + $formValidator.rules.email"
              v-model="user.email"
              :error-messages="errors.collect('email')"
              :class="{
                'form-control': true,
                'is-invalid': errors.has('email')
              }"
              type="email"
              class="form-control"
              data-vv-name="email"
              placeholder="User Email">
            <div :class="{ 'validation-feedback': true, 'invalid-feedback': errors.has('email') }">
              {{ errors.first('email') }}
            </div>
          </td>
        </tr>
        <tr>
          <td>
            <router-link
              to="/users"
              class="btn btn-dark">Cancel</router-link>
          </td>
          <td class="text-right">
            <input
              :disabled="!!errors.items.length"
              type="submit"
              value="Create"
              class="btn btn-info">
          </td>
        </tr>
      </table>
    </form>
  </div>
</template>

<script>
export default {
  name: 'New',
  data () {
    return {
      user: {
        name: null,
        email: null
      }
    }
  },
  computed: {},
  methods: {
    async addUser (event) {
      await this.$post('users/create_user', this.user)
      this.$router.push('/users')
    }
  }
}
</script>

<style>
.table-create-user {
  background-color: #f0f6f7;
}

.table-create th {
  background-color: #f0f6f7;
}
.table-create thead th{
  background-color: rgb(254, 255, 246);
}
</style>
